<template>
    <table class="table table-striped">
        <thead>
            <tr>
                <td>
                    <localized-text localizedKey="Importo lordo" text="Importo lordo"></localized-text>
                </td>
                <td>
                    <localized-text localizedKey="% iva" text="% iva"></localized-text> (0 - 100)
                </td>
            </tr>
        </thead>
        <tbody>
            <tr>
                <td>
                    <input type="number" class="form-control" v-model="localValue.grossAmount" />
                    <div>
                        Importo netto: {{$filters.currency(ivaAmount)}}
                    </div>
                </td>
                <td>
                    <input type="number" class="form-control" v-model="localValue.vatPerc" /><br/>
                </td>
                <td>
                    <div class="form-group">Valuta</div>
                    <select class="form-control" v-model="localValue.symbol">
                        <option>AuraCoin</option>
                        <option>€</option>
                    </select>
                </td>
            </tr>
        </tbody>
    </table>
</template>

<script lang="ts">
import * as OM from '@/model';
import { mixins, Options, Vue } from 'vue-class-component';
import WithModel from '@/mixins/withModel';
import { Prop } from 'vue-property-decorator';

@Options({})
export default class priceConfig extends mixins(WithModel) {

    @Prop() hidePoints: boolean

    declare localValue: OM.PriceConfig;

    get ivaAmount(){
        return this.localValue.grossAmount / (1 + this.localValue.vatPerc / 100);
    }

}

</script>
